/* eslint-disable */
<template>
  <div>
    <app-cabin :title="title" :description="description" :slides="slides" :imgDir="imgDir" :facebookUrl="facebookUrl" :vrboUrl="vrboUrl" ></app-cabin>
  </div>
</template >

<link rel="stylesheet" href="vue-sidebar-menu/dist/vue-sidebar-menu.css"/>
<link rel="stylesheet" href="vue-ical-calendar/dist/vue-ical-calendar.css"/>

<script>
import Cabin from './shared/Cabin';

export default {
  components:{
    'app-cabin': Cabin
  },
  data() {
    return {
          title: 'The Rowdy Coyote Cabin',
          description: 'The Rowdy Coyote Cabin is  Brand New located on a 1.24 wooded lot in Pine Hills. The Rowdy Coyote cabin is the perfect get-away for a family. You will find extraordinary attention to unique design in this split level cabin. Come and Relax with all the comfortable accommodations. The living area, with floor to ceiling windows, has a comfortable sofa and chair in front of a gas burning fireplace with a timer switch for cozy lounging and a large SMART TV with cable package. The master bedroom located downstairs houses a log frame king size memory foam bed with luxury linens and a large SMART TV with cable package for late night movies.  The lovely spiral staircase will lead you up to the beautiful large loft area which houses two log framed twin memory foam beds and a large SMART TV with cable package. This area you will also find many family games, XBox and a multi game barrel style arcade. There is a full size bathroom downstairs with a walk in stand up shower. The kitchen area has black appliances which include a stove, microwave, refrigerator, and dishwasher. Small appliances include an all in one coffee maker/Keurig, blender, hand mixer, toaster, griddle and crockpot. Fully equipped with all the cooking essentials you will need. Dining is at the unique Wine Barrel Table with 4 Barstools. There is a full size washer/dryer and iron/ironing board located in the hallway. This stunning, unique cabin has Fios WIFI, cable package, a park style grill, fire pit, horseshoe pit, hook and ring toss, foosball, zipline, barrel arcade table(with all your favorite arcades such as Pac-Man) and a hot tub. The Rowdy Coyote is located just minutes away from local restaurants, wineries and shopping. Be sure to check out Beavers Bend State Park, Broken Bow Lake and Marina as well as all the other attractions. This spacious one bedroom/loft luxury cabin will accommodate 4 guest and will charm your heart!<br><br><h4>For Larger Groups</h4>Please check out our other cabins the Rowdy Beaver, Rowdy Fox or Rowdy Bear.',
          slides: [],
          imgDir: '../assets/cabins/rowdy-coyote/',
          facebookUrl: 'https://www.facebook.com/Rowdy-Coyote-Cabin-110012737559804',
          vrboUrl: 'https://www.vrbo.com/2059003'
    };
  },
  mounted() {
    this.importAll(require.context('../assets/cabins/rowdy-coyote/', true, /\.jpg$/));
  },
    methods:{
      importAll(r) {
        r.keys().forEach(key => (this.slides.push({ src: r(key), name: key })));
    }
  }

};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img {
  height: 200px;
  object-fit: scale-down;
}
p{
  margin-left: 400px;
  margin-right: 100px;
}
.myDiv {
background-color:lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Coyote.vue